import PropTypes from "prop-types";
import React, { Component } from "react";
import "react-drawer/lib/react-drawer.css";
import "./ticker.css";

import { connect } from "react-redux";
import { Row, Col } from "reactstrap";

import { Link } from "react-router-dom";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import megamenuImg from "../../assets/images/megamenu-img.png";

// import images
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

import flamingosm from "../../assets/images/brands/favicon.svg";


//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import { toggleRightSidebar } from "../../store/actions";
import { Modules } from "../../common/data/constants";
import { decryptData } from "helpers/crypto_helper";
import { withRouter } from "react-router-dom";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      open: false,
      position: "right",
      accessRights: [],
      fabActive: false,
      showNotif: true,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }
  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  /**
   * Toggles the sidebar
   */
  toggleRightbar() {
    this.props.toggleRightSidebar();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }


  componentDidMount() {
    // Get access rights from localStorage
    let accessRightsStr = JSON.stringify(localStorage.getItem("accessRights"));
    if (accessRightsStr) {
      try {
        const decryptedData = decryptData(JSON.parse(accessRightsStr)); // Ensure decryption is handled
        this.setState({ accessRights: JSON.parse(decryptedData) || [] });
      } catch (error) {
        console.error("Error parsing access rights:", error);
      }
    }
    // Check ticker closed state
    const tickerClosed = localStorage.getItem("tickerClosed");
    if (tickerClosed === "true") {
      this.setState({ showNotif: false });
    }
  }

  hasReadAccess = (moduleCode) => {
    const { accessRights } = this.state;
    return accessRights.some(
      (right) => right.module_code === moduleCode && right.read_access === 1
    );
  };

  renderMenuItems() {
    // Filter modules based on read access
    const filteredModules = Modules.filter(
      (module) => this.hasReadAccess(module.module_code)
    );

    // Group modules by main_menu and filter only "Setup" and "Configuration"
    const groupedModules = filteredModules.reduce((acc, module) => {
      if (["Setup", "Configuration"].includes(module.main_menu)) {
        if (!acc[module.main_menu]) acc[module.main_menu] = [];
        acc[module.main_menu].push(module);
      }
      return acc;
    }, {});

    return Object.keys(groupedModules).map((mainMenu, index) => (
      <Col md={6} key={index}>
        <h5 className="mt-0 fw-bold">{this.props.t(mainMenu)}</h5>
        <ul className="list-unstyled megamenu-list">
          {groupedModules[mainMenu].map((module) => (
            <li key={module._id}>
              <Link to={module.module_route}>
                {/* <i className={module.module_icon}></i> {this.props.t(module.module_name)} */}
                {this.props.t(module.module_name)}
              </Link>
            </li>
          ))}
        </ul>
      </Col>
    ));
  }

  goToAttendance = () => {
    this.props.history.push("/my-attendance");
  };
  toggleFab = () => {
    this.setState((prevState) => ({
      fabActive: !prevState.fabActive,
    }));
  };

  closeNotif = () => {
    this.setState({ showNotif: false }, () => {
      localStorage.setItem("tickerClosed", "true");
    });
  }
  render() {
    //  const {showNotif}=this.state;
    const { showNotif } = this.state;

    // Motivational points array
    const motivationalPoints = [
      "Your time represents your dedication and growth. Logging it daily turns effort into progress and helps build a culture of transparency and achievement.",
      "Every minute you track adds value to your journey. Stay consistent with timesheets and let your work speak clearly.",
      "Small daily habits shape long-term success. Update your timesheet and take ownership of your professional progress.",
      "Tracking time brings clarity, focus, and confidence. Make it part of your daily routine and move forward with purpose.",
      "Your work deserves visibility and recognition. Accurate timesheets ensure your contributions are always counted."
    ];
    // Get day of week (0=Sunday, 1=Monday, ... 6=Saturday)
    const today = new Date();
    // Start from Monday (1) as first point, so shift index: (day+6)%7
    const dayIndex = (today.getDay() + 6) % 7; // Monday=0, Sunday=6
    const pointOfTheDay = motivationalPoints[dayIndex % motivationalPoints.length];

    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box d-lg-none d-md-block">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={flamingosm} alt="" height="50" width="30px" style={{ marginBottom: "5px" }} />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={flamingosm} alt="" height="50" width="30px" style={{ marginBottom: "5px" }} />
                  </span>
                </Link>
              </div>

              <button
                type="button"
                onClick={this.toggleMenu}
                className="btn btn-sm px-3 font-size-20 header-item"
                id="vertical-menu-btn"
              >
                <i className=" dripicons-menu"></i>
              </button>

              {/* <Dropdown
                className="dropdown-mega d-none d-lg-block ms-2"
                isOpen={this.state.megaMenuDrp}
                toggle={() => {
                  this.setState({ megaMenuDrp: !this.state.megaMenuDrp });
                }}
              >
                <DropdownToggle className="btn header-item" caret tag="button">
                  {" "}
                  {this.props.t("Mega Menu")}{" "} */}
              {/* <i className="mdi mdi-chevron-down"></i> */}
              {/* </DropdownToggle>
                <DropdownMenu className="dropdown-megamenu">
                  <Row>
                    <Col sm={8}>
                      <Row>{this.renderMenuItems()}</Row>
                    </Col>
                    <Col sm={4}>
                      <Row className="mega-lft-img">
                        <Col sm={6}>
                          <div>
                            <img
                              src={megamenuImg}
                              alt=""
                              className="img-fluid mx-auto d-block mega-menu-img"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </DropdownMenu>
              </Dropdown> */}
            </div>
            <div className="d-flex align-items-center">
              <div className="dropdown d-inline-block d-lg-none ms-2">
                <button
                  onClick={() => {
                    this.setState({ isSearch: !this.state.isSearch });
                  }}
                  type="button"
                  className="btn header-item noti-icon"
                  id="page-header-search-dropdown"
                >
                  <i className="mdi mdi-magnify"></i>
                </button>
                <div
                  className={
                    this.state.isSearch
                      ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                      : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                  }
                  aria-labelledby="page-header-search-dropdown"
                >
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            <i className="mdi mdi-magnify"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* <LanguageDropdown />

              <Dropdown
                className="d-none d-lg-inline-block ms-1"
                isOpen={this.state.socialDrp}
                toggle={() => {
                  this.setState({ socialDrp: !this.state.socialDrp });
                }}
              >
                <DropdownToggle
                  className="btn header-item noti-icon"
                  tag="button"
                >
                  <i className="bx bx-customize"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                  <div className="px-lg-2">
                    <Row className="no-gutters">
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={github} alt="Github" />
                          <span>GitHub</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={bitbucket} alt="bitbucket" />
                          <span>Bitbucket</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={dribbble} alt="dribbble" />
                          <span>Dribbble</span>
                        </Link>
                      </Col>
                    </Row>

                    <Row className="no-gutters">
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={dropbox} alt="dropbox" />
                          <span>Dropbox</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={mail_chimp} alt="mail_chimp" />
                          <span>Mail Chimp</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={slack} alt="slack" />
                          <span>Slack</span>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </DropdownMenu>
              </Dropdown> */}

              <div className="dropdown d-none d-lg-inline-block ms-1">
                <button
                  type="button"
                  onClick={this.toggleFullscreen}
                  className="btn header-item noti-icon"
                  data-toggle="fullscreen"
                >
                  <i className="bx bx-fullscreen"></i>
                </button>
              </div>

              <div className="dropdown d-none d-lg-inline-block ms-1">
                <button
                  type="button"
                  onClick={this.goToAttendance}
                  className="btn header-item noti-icon"
                >
                  <i className="bx bx-calendar"></i>
                </button>
              </div>

              <NotificationDropdown />
              <ProfileMenu />

              {/* <div className="dropdown d-inline-block">
                <button
                  onClick={() => {
                    this.toggleRightbar();
                  }}
                  type="button"
                  className="btn header-item noti-icon right-bar-toggle"
                >
                  <i className="bx bx-cog bx-spin"></i>
                </button>
              </div> */}
            </div>
          </div>
          {showNotif && (
            <div className="ticker-container">
              <div className="ticker-wrapper">
                <div className="ticker">
                  <span className="ticket-text">{pointOfTheDay}</span>
                  {/* <span className="ticker-text">Limited time offer: Get 10% off on our 1 Litre pack of Ghee!</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span className="ticker-text">Introductory offer: Buy our 150 ml pack of Ghee and get 100 gms Jaggery Powder complimentary. Try our small packs today! </span> */}
                  {/* <span className="ticker-text">
                     Welcome!&nbsp;Happy&nbsp;New&nbsp;Year&nbsp;2026&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Welcome!&nbsp;Happy&nbsp;New&nbsp;Year&nbsp;2026&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Welcome!&nbsp;Happy&nbsp;New&nbsp;Year&nbsp;2026&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Welcome!&nbsp;Happy&nbsp;New&nbsp;Year&nbsp;2026&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Welcome!&nbsp;Happy&nbsp;New&nbsp;Year&nbsp;2026&nbsp;
                  </span> */}
                </div>
              </div>
              <button className="ticker-close" onClick={this.closeNotif} aria-label="Close Ticker">×</button>
            </div>
          )}
        </header>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  t: PropTypes.any,
  toggleMenuCallback: PropTypes.any,
  showRightSidebar: PropTypes.any,
  toggleRightSidebar: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar } = state.Layout;
  return { layoutType, showRightSidebar };
};

// export default connect(mapStatetoProps, { toggleRightSidebar })(
//   withTranslation()(Header)
// );

export default withRouter(
  connect(mapStatetoProps, { toggleRightSidebar })(
    withTranslation()(Header)
  )
);